<template>
  <div class="content">
    <div class="tableTit">
      <p class="tabtitBg"></p>
      <h6>各级责任人清单</h6>
      <el-button class="titBtn" type="warning" icon="el-icon-delete" @click="deleteClick()"> 删&nbsp;除 </el-button>
      <el-button class="titBtn" type="primary" icon="el-icon-download" @click="downloadClick(2)">导出</el-button>
      <div class="import-s">
        <p class>
          <span class="el-icon-upload2"></span>导入
        </p>
      <div class="loading-overlay" v-if="loadingVisible">
        <el-progress type="circle" :percentage="loadingPercentage" :stroke-width="20" ></el-progress>
        <p class="tips_css" style="font-size: 24px; color: rgb(30, 160, 225);position: fixed; margin-top : 200px;">{{flag ? "数据正在更新中，请稍后..." : "数据正在导出中，请稍后..."}}</p>
      </div>
        <input type="file" @change="xzdata($event)" />
        <!---->
      </div>
      <el-button class="titBtn" type="success" icon="el-icon-download" @click="download">模板下载</el-button>
      <el-button class="titBtn" type="primary" icon="el-icon-download" @click="downloadClick(1)">全部导出</el-button>
      <!-- <addressTree @obj="objdata" @close="treeClose"></addressTree> -->
    </div>
    <!--<div class="trees">
			<el-tree :default-expand-all='true' :expand-on-click-node="false" ref="tree" class="treeClass" :filter-node-method="filterNode" :data="treedata" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
		</div>-->
    <div class="tabBody">
      <el-table ref="multipleTable" @selection-change="handleSelectionChange" :header-cell-style="{background:'rgba(49,130,222,0.1)'}" :data="tabledata" :height="tableHeight" border>
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column type="index" align='center' width="45" label="序号"></el-table-column>
        <el-table-column prop="ydbSheng" align='center' label="省"></el-table-column>
        <el-table-column prop="ydbShi" align='center' label="市"></el-table-column>
        <el-table-column prop="ydbXian" align='center' label="县"></el-table-column>
        <el-table-column prop="ydbXiang" align='center' label="乡"></el-table-column>
        <el-table-column prop="ydbCun" align='center' label="村"></el-table-column>
        <el-table-column prop="ydbName" width="180" align='center' label="淤地坝名称"></el-table-column>
        <el-table-column prop="ydbCode" width="180" align='center' label="编码"></el-table-column>
        <el-table-column prop="ydbXzzrr" width="90" align='center' label="行政责任人"></el-table-column>
        <el-table-column prop="ydbXzzrrzw" width="160" align='center' label="行政责任人职务"></el-table-column>
        <el-table-column prop="ydbXzzrrlxfs" width="130" align='center' label="行政责任人联系方式"></el-table-column>
        <el-table-column prop="ydbJszrr" width="90" align='center' label="技术责任人"></el-table-column>
        <el-table-column prop="ydbJszrrzw" width="160" align='center' label="技术责任人职务"></el-table-column>
        <el-table-column prop="ydbJszrrlxfs" width="130" align='center' label="技术责任人联系方式"></el-table-column>
        <el-table-column prop="ydbXczrr" width="90" align='center' label="巡查责任人"></el-table-column>
        <el-table-column prop="ydbXczrrzw" width="160" align='center' label="巡查责任人职务"></el-table-column>
        <el-table-column prop="ydbXczrrlxfs" width="130" align='center' label="巡查责任人联系方式"></el-table-column>
        <!-- <el-table-column prop="ydbXianjZfzrLxfs" align='center' label="县级总负责人联系方式"></el-table-column> -->
        <!-- <el-table-column prop="proName" align='center' label="备注"></el-table-column> -->
        <el-table-column prop="" label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-download" class="tableedit" round @click='downloadrow(scope.$index,scope.row)'></el-button>
            <el-button type="success" icon="el-icon-edit" circle @click="edit(scope.$index,scope.row)" class="btnmargin"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fye">
      <pagintion @dsydata='DsyData' @dstdata="DstData" :total='total' :pageNums="pageNums"></pagintion>
    </div>
    <personliablepopup v-if="dialogVisible == true" :mystate="Addsid" @bjadddata="Bjadddata" @getcancel="Getcancel">
    </personliablepopup>

  </div>
</template>

<script>
import addressTree from '@/components/mangement/addressTree.vue';
import pagintion from '@/components/mangement/pagintion.vue';
import personliablepopup from '../popup/personliablepopup.vue'

import Url from '@/common/js/Url.js';
import axios from "axios";
import {
  ydbzrrQuery,
  ydbdeleteZrrInfo
} from '@/api/api.js'

export default {
  data() {
    return {
      downloadName:'淤地坝责任人导入模板',
      tableHeight: window.innerHeight - 180,
      tabledata: [],
      treedata: [{
        name: '陕西省',
        id: 0,
        child: [{
          name: '榆林市',
          id: 1,
          child: [{
            name: '绥德县',
            id: 2,
            child: []
          },]
        },
        {
          name: '西安市',
          id: 1,
          child: [{
            name: '榆阳区',
            id: 2,
            child: []
          },]
        }
        ]
      }],
      defaultProps: {
        children: 'child',
        label: 'name',

      },
      total: 0,
      pageSize: 20, //每页多少条数据分页
      pageNum: 1, //当前页
      pageNums: null,
      multipleSelection: [],
      dialogVisible: false,
      Addsid: [],
      timer: null,//定时器
      flag:false,
      loadingVisible: false,//开启遮罩
      loadingPercentage: 0 //进度百分比
    }
  },
  components: {
    addressTree,
    pagintion,
    personliablepopup
  },
  mounted() {
    let params = {
      pageSize: this.pageSize,
      pageNum: this.pageNum,
    }
    this.list(params)
  },
  methods: {
    treeClose() {
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,


      }
      this.list(params)
    },
    Bjadddata() {
      this.dialogVisible = false;
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      }
      this.list(params)
    },
    Getcancel() {
      this.dialogVisible = false;

    },

    startLoading() {
      this.loadingVisible = true;
      this.loadingPercentage = 0;     
      this.timer = setInterval(() => {
        if (this.loadingPercentage < 90) {
          this.loadingPercentage += 1;
        }
      }, 5000);
    },

    download() {
      //window.location.href = '/userApi/ydb/basic/exportZrr';
      const headers = {
          "Access-Token": this.$store.state.token
        };
      axios.get('/userApi/ydb/basic/exportZrr', {
        method: "GET",
        headers,
        params:null,
        responseType: "blob" // 设置响应类型为blob
      })
      .then(res => {
         // 创建一个虚拟的链接元素，模拟点击下载
         const link = document.createElement("a");
          let blob1 = new Blob([res.data], { type: "application/octet-stream;" });
          link.href = window.URL.createObjectURL(blob1);
          link.download = this.downloadName+'.xlsx'; // 设置下载文件名，替换filename.ext为实际的文件名和扩展名
          document.body.appendChild(link);
          // 模拟点击
          link.click();
          // 移除虚拟链接元素
          document.body.removeChild(link);
      })
      .catch(error => {
        console.error('请求失败:', error);
        // 处理错误
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    list(params) {
      ydbzrrQuery(params).then((res) => {
        // console.log(res)
        this.total = res.total;
        this.tabledata = res.data;
      })
    },
    objdata(data) {
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbCode: data.ydbCode

      }
      this.list(params)
    },
    DsyData(data) { //多少页
      this.pageNum = data.dsy;
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,

      }
      this.list(params)

    },
    DstData(data) { //多少条
      this.pageSize = data.dst;
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,

      }
      this.list(params)
    },
    downloadrow(index, row) {
      let ids = [];
      ids.push(row.ydbCode);
      let strIds = ids.toString();
      //window.location.href = '/userApi/ydb/basic/downZrrInfo?ydbCodes=' + strIds;
      const headers = {
          "Access-Token": this.$store.state.token
        };
      axios.get('/userApi/ydb/basic/downZrrInfo?ydbCodes=',{
        method: "GET",
        headers,
        params:{ydbCodes:strIds},
        responseType: "blob" // 设置响应类型为blob
        
      }).then(res => {
          // 创建一个虚拟的链接元素，模拟点击下载
          // const link = document.createElement("a");
          // let blob1 = new Blob([res.data], { type: "application/octet-stream;" });
          // link.href = window.URL.createObjectURL(blob1);
          
          
          // link.download = downloadName+'.zip'; // 设置下载文件名，替换filename.ext为实际的文件名和扩展名
          // document.body.appendChild(link);
          // // 模拟点击
          // link.click();
          // // 移除虚拟链接元素
          // document.body.removeChild(link);

          const link = document.createElement("a");
          let blob1 = new Blob([res.data], { type: "application/octet-stream;" });
          link.href = window.URL.createObjectURL(blob1);
          
          link.download = '淤堤坝基础数据.xlsx'; // 设置下载文件名，替换filename.ext为实际的文件名和扩展名
          document.body.appendChild(link);
          // 模拟点击
          link.click();
          // 移除虚拟链接元素
          document.body.removeChild(link);
         
        })
        .catch(error => console.error("下载失败：", error));
    },
    edit(index, row) {
      this.Addsid = [row]
      this.dialogVisible = true;
    },
    downloadClick(type) {
      if (type == 1) {
        this.flag = false;
        const regionCode = this.$store.state.regionCode
        // console.log('----------------------->', regionCode)
        //window.location.href = '/userApi/ydb/basic/downZrrInfo?regionCode=' + regionCode;
        const headers = {
          "Access-Token": this.$store.state.token
        };
        this.laoding = true;
        this.startLoading();
        axios.get('/userApi/ydb/basic/downZrrInfo',{
        method: "GET",
        headers,
        params:{regionCode:regionCode},
        responseType: "blob" // 设置响应类型为blob
        
      }).then(res => {
          // 创建一个虚拟的链接元素，模拟点击下载
          // const link = document.createElement("a");
          // let blob1 = new Blob([res.data], { type: "application/octet-stream;" });
          // link.href = window.URL.createObjectURL(blob1);
          
          
          // link.download = downloadName+'.zip'; // 设置下载文件名，替换filename.ext为实际的文件名和扩展名
          // document.body.appendChild(link);
          // // 模拟点击
          // link.click();
          // // 移除虚拟链接元素
          // document.body.removeChild(link);

          const link = document.createElement("a");
          let blob1 = new Blob([res.data], { type: "application/octet-stream;" });
          link.href = window.URL.createObjectURL(blob1);
          
          link.download = '淤地坝责任人数据.xlsx'; // 设置下载文件名，替换filename.ext为实际的文件名和扩展名
          document.body.appendChild(link);
          // 模拟点击
          link.click();
          // 移除虚拟链接元素
          document.body.removeChild(link);
          clearInterval(this.timer); // 停止计时器
            this.loadingPercentage=100;
            // 延时 1 秒后执行关闭遮罩或其他操作
            setTimeout(() => {
              this.loadingVisible = false;
            }, 1000);
          
        }).catch(error => {console.error("下载失败：", error)
        clearInterval(this.timer); // 停止计时器
            this.loadingPercentage=100;
            // 延时 1 秒后执行关闭遮罩或其他操作
            setTimeout(() => {
              this.loadingVisible = false;
              // 关闭遮罩或执行其他操作
            }, 1000);
        });
      } else {
        if (this.multipleSelection.length == 0) {
          this.$notify({
            title: "提示",
            message: "请选择要下载的数据！",
            type: "warning",
          });
        } else {
          let ids = [];
          for (let i = 0; i < this.multipleSelection.length; i++) {
            ids.push(this.multipleSelection[i].ydbCode);
          }
          let strIds = ids.toString();
        //window.location.href = '/userApi/ydb/basic/downZrrInfo?ydbCodes=' + strIds;
        const headers = {
          "Access-Token": this.$store.state.token
        };
        axios.get('/userApi/ydb/basic/downZrrInfo',{
        method: "GET",
        headers,
        params:{ydbCodes:strIds},
        responseType: "blob" // 设置响应类型为blob
        
      }).then(res => {
          // 创建一个虚拟的链接元素，模拟点击下载
          // const link = document.createElement("a");
          // let blob1 = new Blob([res.data], { type: "application/octet-stream;" });
          // link.href = window.URL.createObjectURL(blob1);
          
          
          // link.download = downloadName+'.zip'; // 设置下载文件名，替换filename.ext为实际的文件名和扩展名
          // document.body.appendChild(link);
          // // 模拟点击
          // link.click();
          // // 移除虚拟链接元素
          // document.body.removeChild(link);

          const link = document.createElement("a");
          let blob1 = new Blob([res.data], { type: "application/octet-stream;" });
          link.href = window.URL.createObjectURL(blob1);
          
          link.download = '淤堤坝基础数据.xlsx'; // 设置下载文件名，替换filename.ext为实际的文件名和扩展名
          document.body.appendChild(link);
          // 模拟点击
          link.click();
          // 移除虚拟链接元素
          document.body.removeChild(link);
         
        })
        .catch(error => console.error("下载失败：", error));
        }
      }
    },
    deleteClick() {
      if (this.multipleSelection.length == 0) {
        this.$notify({
          title: "提示",
          message: "请选择要删除的数据！",
          type: "warning",
        });
      } else {

        this.$confirm('此操作将永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(action => {
          if (action === 'confirm') {
            let ids = [];
            for (let i = 0; i < this.multipleSelection.length; i++) {
              ids.push(this.multipleSelection[i].id);
            }

            ydbdeleteZrrInfo(ids).then((res) => {
              if (res.code == 200) {
                this.$notify({
                  title: "提示",
                  message: "删除成功！共删除" + res.data + "条数据",
                  type: "success",
                });
                let params = {
                  pageSize: this.pageSize,
                  pageNum: this.pageNum,

                };
                this.list(params);
              } else {
                this.$notify({
                  title: "提示",
                  message: "删除失败！",
                  type: "success",
                });
              }
            });

          }
        }).catch(() => {

        });

      }
    },
    xzdata(e) {

      let file = e.target.files[0];
      let filename = file.name.split(".")[
        file.name.split(".").length - 1
      ];

      let filenames = file.name;
      let fileSize = file.size / 1024 / 1024 < 1000000;

      if (fileSize) {
        if (filename != "xlsx") {
          this.$notify({
            title: "提示",
            message: "请选择xls文件",
            type: "success",
          });
          e.target.value = null;
        } else {
          let formData = new FormData();
          formData.append("file", file);
          /*formData.append("importFile", file);
          formData.append("no", this.treeno);
          formData.append("proId", this.proID);*/
          let config = {
            headers: {
              "Content-Type": "multipart/form-data",
              //"login-token": this.$store.state.logintoken,
            },
          }; // 添加请求头

          axios.post("/importfile/ydb/basic/importZrr", formData, config).then((res) => {
            if (res.data.code == 200) {
              this.$notify({
                title: "提示",
                message: res.data.message,
                type: "success",
              });
              let params = {
                pageSize: this.pageSize,
                pageNum: this.pageNum,
              };
              this.list(params);
              e.target.value = null;
            } else {
              this.$notify({
                title: "提示",
                message: res.data.message,
                type: "warning",
              });
            }
          }).catch((err) => { });
        }
      } else {
        this.$message({
          message: "文件不能大于10M",
          type: "success",
        });
        e.target.value = null;
      }

    },
  }

}
</script>

<style scoped>
@import url("../../../common/css/mangementall.css");
.loading-overlay {
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
::v-deep .el-progress__text{
  font-size: 24px !important;
  color: rgb(30, 160, 225) !important;
}
::v-deep .el-progress-circle{
  width: 150px !important;
  height: 150px !important;
}
.tips_css{
  font-size: 24px;
  color: rgb(30, 160, 225)
}
.zblxtree {
  width: 230px;
  height: calc(100% - 80px);
  height: -webkit-calc(100% - 80px);
  height: -moz-calc(100% - 80px);
  background: #f7f7f7;
  border-radius: 6px;
  float: left;
  overflow: auto;
  padding: 15px;
}

.zblxtreeSty {
  background: #f7f7f7;
  border-radius: 6px;
}

.tablelist {
  width: 100%;
  height: calc(100% - 50px);
  height: -webkit-calc(100% - 50px);
  height: -moz-calc(100% - 50px);
  float: right;
  position: relative;
}

.tablelistbox {
  width: 100%;
  heigt: 100%;
}
 
.clsjTis {
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  margin: auto;
  width: 335px;
  height: 210px;
  border: 1px solid #cccccc;
  background: #f7f7f7;
  border-radius: 6px;
  font-size: 16px;
}

.ycllxname {
  float: left;
  line-height: 30px;
  font-size: 14px;
  margin-left: 10px;
  margin-top: 10px;
}

.cllx-select {
  float: left;
  margin-top: 10px;
  width: 230px;
}

.btn {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.zzct {
  font-size: 20px;
  margin-right: 10px;
}

.import-s {
  float: right;
  position: relative;
  width: 100px;
  height: 28px;
  background: #409eff;
  margin-right: 10px;
  border-radius: 4px;
  margin-top: 11px;
  overflow: hidden;
}

.el-input__inner {
  height: 30px;
  line-height: 30px;
  color: #606266;

  font-size: 14px;
}
.zblxtree {
  width: 230px;
  height: calc(100% - 80px);
  height: -webkit-calc(100% - 80px);
  height: -moz-calc(100% - 80px);
  background: #f7f7f7;
  border-radius: 6px;
  float: left;
  overflow: auto;
  padding: 15px;
}

.zblxtreeSty {
  background: #f7f7f7;
  border-radius: 6px;
}

.tablelist {
  width: 100%;
  height: calc(100% - 50px);
  height: -webkit-calc(100% - 50px);
  height: -moz-calc(100% - 50px);
  float: right;
  position: relative;
}

.tablelistbox {
  width: 100%;
  heigt: 100%;
}

.clsjTis {
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  margin: auto;
  width: 335px;
  height: 210px;
  border: 1px solid #cccccc;
  background: #f7f7f7;
  border-radius: 6px;
  font-size: 16px;
}

.ycllxname {
  float: left;
  line-height: 30px;
  font-size: 14px;
  margin-left: 10px;
  margin-top: 10px;
}

.cllx-select {
  float: left;
  margin-top: 10px;
  width: 230px;
}

.btn {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.zzct {
  font-size: 20px;
  margin-right: 10px;
}

.import-s {
  float: right;
  position: relative;
  width: 100px;
  height: 28px;
  background: #409eff;
  margin-right: 10px;
  border-radius: 4px;
  margin-top: 11px;
  overflow: hidden;
}

.import-s p {
  position: absolute;
  width: 100%;
  line-height: 28px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}

.import-s p span {
  margin-right: 5px;
}

.import-s input {
  width: 100%;
  height: 28px;
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

>>> .el-input__inner {
  height: 30px;
  line-height: 30px;
  color: #606266;

  font-size: 14px;
}
</style>
